import { useState, useRef } from "react";
import { Mic, MicOff } from "lucide-react";

export function VoiceInput({ value, onChange, placeholder, testId = "voice-textarea", rows = 5 }) {
  const [recording, setRecording] = useState(false);
  const recRef = useRef(null);

  const toggle = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      alert("Reconnaissance vocale non supportée par ce navigateur. Utilisez Chrome ou Edge.");
      return;
    }
    if (recording) {
      recRef.current?.stop();
      setRecording(false);
      return;
    }
    const rec = new SR();
    rec.lang = "fr-FR";
    rec.continuous = true;
    rec.interimResults = true;
    let finalText = value || "";
    rec.onresult = (e) => {
      let interim = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) finalText += e.results[i][0].transcript + " ";
        else interim += e.results[i][0].transcript;
      }
      onChange((finalText + interim).trim());
    };
    rec.onerror = () => setRecording(false);
    rec.onend = () => setRecording(false);
    rec.start();
    recRef.current = rec;
    setRecording(true);
  };

  return (
    <div className="relative">
      <textarea
        className="j-textarea pr-14"
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
      />
      <button
        type="button"
        onClick={toggle}
        className={`absolute right-3 bottom-3 w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
          recording ? "bg-[#EF4444] text-white animate-pulse" : "bg-slate-100 text-[#1E293B] hover:bg-slate-200"
        }`}
        data-testid={`${testId}-mic-btn`}
        aria-label={recording ? "Arrêter la dictée" : "Démarrer la dictée"}
      >
        {recording ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
      </button>
    </div>
  );
}

export function EvidenceBadge({ level }) {
  const map = {
    green: { cls: "evidence-green", dot: "🟢", label: "Confirmé" },
    amber: { cls: "evidence-amber", dot: "🟧", label: "Point de débat" },
    red: { cls: "evidence-red", dot: "🔴", label: "Source insuffisante" },
  };
  const m = map[level] || map.amber;
  return (
    <span className={`evidence-pill ${m.cls}`} data-testid={`evidence-${level}`}>
      <span>{m.dot}</span> {m.label}
    </span>
  );
}

export function ProgressBar({ value = 0, label }) {
  const color = value >= 80 ? "#10B981" : value >= 50 ? "#F59E0B" : "#EF4444";
  return (
    <div data-testid="dossier-ready-score">
      <div className="flex justify-between items-baseline mb-2">
        <span className="j-label">{label || "Complétude du dossier"}</span>
        <span className="font-heading font-black text-2xl" style={{ color }}>{value}%</span>
      </div>
      <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
        <div className="h-full transition-all duration-500" style={{ width: `${value}%`, background: color }} />
      </div>
    </div>
  );
}
